import { fetchWithoutToken } from '../utils/fetch';
import { getGoogleCredentials } from './Login/getGoogleCredentials';

export const getInfoUserGoogle = async (
	codeParam,
	institutionCode,
	googleAuthConfig = null,
) => {
	try {
		const googleCredentials = getGoogleCredentials(institutionCode);
		const redirectUri =
			googleAuthConfig?.redirect_uri ||
			googleAuthConfig?.redirectUri ||
			googleCredentials.redirect_uri;

		const res = await fetchWithoutToken.post(
			`/google`,
			{
				code: codeParam,
				institution_code: institutionCode,
				redirect_uri: redirectUri,
			},
			{
				headers: {
					Authorization: `Bearer ${localStorage.token}`,
				},
			},
		);

		return res;
	} catch (error) {
		const backendDetail = error?.response?.data?.detail;
		const message = Array.isArray(backendDetail)
			? backendDetail.join(', ')
			: backendDetail || 'Google authentication failed.';
		console.error('Google auth error.', error);
		throw new Error(message);
	}
};
